<template>
    <div class="share">
        <Header></Header>
        <div class="share_container">
            <div class="inner">
                <div class="share_top">
                    <div class="file_container">
                        <img src="../../assets/image/资源 32.png">
                        <p style="font-size: 0.8rem; letter-spacing: 1px;">文件大小：{{ file.fileSize }}</p>
                        <el-button @click="openFile">打开文件</el-button>
                    </div>
                </div>
                <div class="share_bottom">
                    <div class="left">
                        <div>
                            <img src="../../assets/image/资源 31.png">
                            <span>【{{ file.fileName }}】</span>
                        </div>
                        <div class="line2">
                            <i class="el-icon-time"></i>
                            <span style="font-size: 0.8rem; color: #b0b0b0; letter-spacing: 1px;">{{ file.createTime }}</span>
                        </div>
                    </div>
                    <div class="right">
                        <el-button @click="downLoad">
                            <img src="../../assets/image/资源 33.png" >
                            下载
                        </el-button>
                        <span>{{ file.fileSize }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import Header from "../../components/header/index.vue"
import Bottom from "../../components/footer/index.vue"
import { getFileInfo } from "../../util/index"
import { openUriWithTimeoutHack } from "../../util/proto.js"

export default {
    data() {
        return {
            file:{
                createTime:'',
                fileName:'',
                fileSize:'',
                url: ''
            }
        }
    },
    methods:{
        downLoad(){
            const jsonContent = JSON.stringify(this.file.url);

            // 创建 Blob 对象
            const blob = new Blob([jsonContent], { type: 'application/json' });

            // 创建下载链接
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.file.fileName+'.json';
            a.style.display = 'none';

            // 添加链接到页面并触发点击
            document.body.appendChild(a);
            a.click();

            // 释放 URL 对象
            URL.revokeObjectURL(url);

        },
        openFile(){
            const appUri = 'weixin://'; // 应用程序的地址(注册表应用名称)
            const timeoutDuration = 1000;

            const openAppFailure = () => {
                const url = 'http://pongo.net.cn/';
                const res = confirm('PONGO未安装，请下载并安装PONGO。');
                if (res) {
                    window.location.href = url; // window.open会被浏览器拦截,使用window.location.href下载exe
                }
            };

            const openAppSuccess = () => {
                console.log('成功打开本地应用程序');
            };

            openUriWithTimeoutHack(appUri, openAppFailure, openAppSuccess, timeoutDuration);
        }
    },
    components: {
        Header,
        Bottom
    },
    mounted() {
        let id = this.$route.query.id
        getFileInfo({id}).then(res => {
            if(res.code === '0'){
                this.file.fileName = res.data.fileName
                // 保留两位小数
                this.file.fileSize = (res.data.fileSize / 1024).toFixed(2) + 'KB'
                this.file.url = res.data.url
                let time = new Date(Number(res.data.createTime))
                this.file.createTime = time.toLocaleString()
            }
        })
    }
}
</script>

<style scoped lang="less">
.share{
    background-color: #b0b0b0;
}
.share_container{
    width: 90%;
    margin: 0 auto;
    padding: 2rem 0 10rem 0;
    .inner{
        margin: 0 auto;
        border-radius: 10px;
        width: 70%;
        background-color: #fff;
    }
    .share_top{
        display: flex;
        justify-content: center;
        padding: 2rem 0;
        // background-color: #f77e7e;
        border-bottom: 1px dashed #d8d8d8;
        .file_container{
            width: 95%;
            height: 95%;
            background-color: #dcfbff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 10rem 0;
            ::v-deep .el-button{
                color: #fff;
                background: #54d1ef;
            }
            ::v-deep .el-button:hover{
                color: #54d1ef;
                background: #fff;
            }
            p{
                margin: 1rem 0;
            }
        }
    }
    .share_middle{
        width: 70%;
        margin: 0 auto;
        padding: 2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        white-space: pre-line;
        p{
            width: 100%;
            color: #aeaeae;
            letter-spacing: 1px;
            line-height: 2;
            text-align: left;
            white-space: pre-line;
        }
        img{
            width: 30rem;
            margin: 0 auto;
            padding: 3rem 0;
        }
    }
    .share_bottom{
        // border-top: 1px solid #d8d8d8;
        padding: 2rem 3rem;
        display: flex;
        justify-content: space-between;
        .left{
            // background-color: coral;
            span{
                margin-left: 0.5rem;
            }
            .line2{
                margin-top: 0.5rem;
            }
        }
        .right{
            display: flex;
            flex-direction: column;
            align-items: center;
            ::v-deep .el-button{
                background-color: #54d1ef;
                border: none;
                color: #fff;
            }
            span{
                margin-top: 0.5rem;
                font-size: 0.8rem;
                color: #bdbdbd;
            }
        }
    }
}
</style>